import { forwardRef, type Ref, type SVGProps } from "react";

function SvgInfo(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.167 7.333H8v3.5M14.167 8A6.167 6.167 0 1 1 1.833 8a6.167 6.167 0 0 1 12.334 0"
      />
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.167}
        d="M7.583 5.333a.417.417 0 1 0 .834 0 .417.417 0 0 0-.834 0Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgInfo);
export default ForwardRef;
